var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhiteLogoMid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 76,
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 353.69 111.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f2f2f2;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m42.47,0h26.57C92.48,0,111.51,19.03,111.51,42.47v26.57c0,23.44-19.03,42.47-42.47,42.47H0V42.47C0,19.03,19.03,0,42.47,0Z",
    transform: "translate(111.51 0) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m163.57,0h26.57C213.58,0,232.61,19.03,232.61,42.47v26.57c0,23.44-19.03,42.47-42.47,42.47h-69.04V42.47C121.1,19.03,140.13,0,163.57,0Z",
    transform: "translate(353.71 111.51) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m242.18,0h69.04C334.66,0,353.69,19.03,353.69,42.47v26.57c0,23.44-19.03,42.47-42.47,42.47h-26.57c-23.44,0-42.47-19.03-42.47-42.47V0h0Z",
    transform: "translate(595.87 111.51) rotate(-180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLogoMid);
export default __webpack_public_path__ + "static/media/whiteLogoMid.c6d42690d63179010832cf6af260cf35.svg";
export { ForwardRef as ReactComponent };